import DownloadListItem from './downloadListItem/DownloadListItem.vue';
import CircleProgress from '@/components/circleProgress/CircleProgress.vue'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'

import {mapGetters} from "vuex";

export default {
    name: 'download-list',
    props: {
        closeMenu:{
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            compactMode: true
        }
    },
    computed: {
        ...mapGetters({
            videos: 'getUplodedVideos',
            videoState: 'getVideoState',
        }),
    },
    components:{
        DownloadListItem,
        CircleProgress,
        VuePerfectScrollbar
    },
    methods:{
        toggle(){
            if(!this.closeMenu) {
                this.compactMode = !this.compactMode;
                this.$emit('changeVisible', !this.compactMode)
            }
        }
    },
    watch: {
        videos() {
            if (!this.videos || !this.videos.length) {
                this.compactMode = true
                this.$emit('changeVisible', !this.compactMode)
            }
        },
        closeMenu() {
            if (this.closeMenu) {
                this.compactMode = true
                this.$emit('changeVisible', !this.compactMode)
            }
        }
    }
};


// WEBPACK FOOTER //
// ./src/components/downloadList/downloadList.js